import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import Select from "react-select";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { setTheExcelsheetUploadDataForEmpCIlent } from "../../../Redux/Slice";
const ExcelFormatDwonload = (props) => {
  const { show, setShow, EditID } = props;

  const Swal = require("sweetalert2");
  const dispatch = useDispatch();
  // console.log(EditID, "EditI44D");
  const [Options, setOptions] = useState([
    // { value: "all", label: "All" },
    // { value: "basic_form", label: "Bacis Form" },
    // { value: "address_form", label: "Address Form" },
    // { value: "id_form", label: "Id Form" },
    // { value: "bank_details_form", label: "Bank Details Form" },
    // { value: "education_details_form", label: "Education details Form" },
    // { value: "employee_previous_form_excel", label: "Employee Previous Form" },

    // // { value: "family_details_form_excel", label: "Family Details Form" },


    // { value: "declaration_form_excel", label: "Declaration Form" },
    // { value: "esi_form_excel", label: "Esi Form" },
    // { value: "job_details_form_excel", label: "Job detail Form" },

    { value: "all", label: "ALL" },
{ value: "basic_form", label: "BASIC FORM" },
{ value: "address_form", label: "ADDRESS FORM" },
{ value: "id_form", label: "ID FORM" },
{ value: "bank_details_form", label: "BANK DETAILS FORM" },
{ value: "education_details_form", label: "EDUCATION DETAILS FORM" },
{ value: "employee_previous_form_excel", label: "EMPLOYEE PREVIOUS FORM" },

// { value: "family_details_form_excel", label: "FAMILY DETAILS FORM" },

{ value: "declaration_form_excel", label: "DECLARATION FORM" },
{ value: "esi_form_excel", label: "ESI FORM" },
{ value: "job_details_form_excel", label: "JOB DETAIL FORM" }



  ]);
  const [selected, setSelected] = useState({ value: "all", label: "All" });
  const [formName, setFormName] = useState("all");
  const HandleAddingChanges = (e) => {
    setSelected(e);
    setFormName(e.value);
  };
  const handleClosepop = (e) => {
    Swal.fire({
      title: `Do you want to exit excel sheet export?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes !",
    }).then((result) => {
      if (result.isConfirmed) {
        setShow(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  const HanldeExport = (e) => {
    Swal.fire({
      title: `Do you want to  export ${selected.label} excel sheet?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          user_id: EditID.user_id,
          client_id: EditID.client_id,
          return_type: EditID.user_id != "" ? "employee" : "client",
          family_type: "one_line",
          previous_type: "one_line",
          form_name: formName,
        };

        dispatch(setTheExcelsheetUploadDataForEmpCIlent(payload));
         setShow(false)
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  return (
    <>
      <div className="Shift RoleCreatePopup">
        <div className="Shift ShiftCreatePopup">
          <div
            // className={`  ${stateDisplay ? " POPUP" : "outerPOPUP"}`}
            className="  BeforeSHIFTPopUp"
          >
            <div className=" BodyShiftContent  " style={{ width: "31%" }}>
              <div className="card">
                <div className="card-body cards ">
                  <div className="UserPoup">
                    <div className="BeforForms" style={{ width: "100%" }}>
                      <div className="Form" style={{ width: "100%" }}>
                        <div className="ModalHeader" style={{ width: "100%" }}>
                       <span>   {EditID.user_id != ""
                            ? " Export excel sheet for  employee"
                            : " Export excel sheet for client"}
                            
</span>
                          <div
                            className="CloseIcon"
                            onClick={(e) => setShow(false)}
                          >
                            <CloseOutlinedIcon />
                          </div>
                        </div>

                        <div className="Modal-Body">
                          <div className="row">
                            <div className="col-6">
                              <label className="form-label">Form List</label>

                              <Select
                               className="Selects"
                                options={Options}
                                onChange={(e) => {
                                  HandleAddingChanges(e);
                                }}
                                value={selected}
                              />
                            </div>
                          </div>

                          <div
                            className="UserButtons"
                            style={{
                              marginTop: "30px",
                              letterSpacing: "1.2px",
                            }}
                          >
                            <button
                              class="  SaveBtn ButtonCSS"
                              type="submit"
                              onClick={(e) => {
                                HanldeExport(e);
                              }}
                            >
                             Kyc Form export Sheet
                            </button>

                            <button
                              class=" CancelBtn ButtonCSS"
                              onClick={(e) => {
                                handleClosepop(e);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExcelFormatDwonload;
